import { ExternalCalendar, ID } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetExternalConnectionCalendarsPayload = {
  externalConnectionId: ID;
};

export type GetExternalConnectionCalendarsOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetExternalConnectionCalendarsPayload;
};

export const getExternalConnectionCalendars = async <TFunctions>(
  options: GetExternalConnectionCalendarsOptions<TFunctions>,
): Promise<ExternalCalendar[]> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    GetExternalConnectionCalendarsPayload,
    ExternalCalendar[]
  >(functions, 'externalConnections-getCalendars');

  const { data } = await callable(payload);

  return data;
};
